export default "https://cdn-static.gokick.com/assets/c9d0de51336abe1332e753a6383b3531473fb45b/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";